import { render, staticRenderFns } from "./AccountList.vue?vue&type=template&id=350ba470&scoped=true"
import script from "./AccountList.vue?vue&type=script&lang=js"
export * from "./AccountList.vue?vue&type=script&lang=js"
import style0 from "./AccountList.vue?vue&type=style&index=0&id=350ba470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ba470",
  null
  
)

export default component.exports